var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_43730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60205 26V5C1.60205 4.20435 1.91812 3.44129 2.48073 2.87868C3.04334 2.31607 3.8064 2 4.60205 2H25.8601C26.2541 1.99982 26.6443 2.07727 27.0084 2.22792C27.3725 2.37857 27.7033 2.59947 27.982 2.878L39.7201 14.62C39.9993 14.8984 40.2209 15.2291 40.3723 15.5932C40.5236 15.9573 40.6017 16.3477 40.6021 16.742V25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.602 17H28.6021C27.8064 17 27.0433 16.6839 26.4807 16.1213C25.9181 15.5587 25.6021 14.7956 25.6021 14V2",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6021 31V43.188C14.6021 43.9338 14.8983 44.649 15.4257 45.1764C15.953 45.7037 16.6683 46 17.4141 46H22.1021",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.102 31H30.078C29.2947 30.9997 28.5342 31.264 27.9199 31.75C27.3055 32.236 26.8734 32.9153 26.6935 33.6777C26.5136 34.4402 26.5965 35.241 26.9288 35.9504C27.261 36.6598 27.8232 37.2361 28.524 37.586L32.18 39.414C32.881 39.764 33.4433 40.3405 33.7755 41.0501C34.1077 41.7597 34.1905 42.5607 34.0103 43.3232C33.8302 44.0858 33.3977 44.7651 32.783 45.2509C32.1683 45.7368 31.4075 46.0008 30.624 46H26.602",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8979 46L46.3979 31",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3979 46L38.8979 31",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10205 46L9.60205 31",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60205 46L2.10205 31",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_43730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXlsx);
export default __webpack_public_path__ + "static/media/FileXLSX.2cabecdee603602cdb72d74069fd22f1.svg";
export { ForwardRef as ReactComponent };